import z from "zod";

export const dailyForecastArraySchema = z.array(
	z.object({
		station_id: z.string(),
		ww: z.number(),
		temperature_max: z.number(),
		temperature_min: z.number(),
	}),
);
